// src/rtkQuery/hooks/useContactFormSubmission.ts
import { toastService } from "@/utils/toastService";
import type { ContactFormSchema } from "@/validation-schemas/contact-us-schemas";
import { useContactUsService } from "./useContactUsService";

export const useContactFormSubmission = () => {
    const {
        contactSubmit,
        contactData,
        contactError,
        contactIsLoading,
        contactIsSuccess,
        contactIsError,
        contactStatus,
        contactErrorMessage,
    } = useContactUsService();

    const submitContactForm = async (formData: ContactFormSchema) => {
        try {
            const response = await contactSubmit(formData).unwrap();
            toastService.success("Thank you! Your message has been sent.");
            return response;
        } catch (err: any) {
            toastService.error(contactErrorMessage);
            throw err;
        }
    };

    return {
        submitContactForm,
        isLoading: contactIsLoading,
        isSuccess: contactIsSuccess,
        isError: contactIsError,
        error: contactError,
        status: contactStatus,
        data: contactData,
        errorMessage: contactErrorMessage,
    };
};